import { createContext, useReducer, useContext, Dispatch, ReactNode } from 'react';
import { IPageStatus, ITimeLine, IProductItem } from './type';
import type { ICurrentPlanInfo } from '@/components/Referral/index.d';

interface MemberProtocolItem {
    title: string;
    desc: string[];
}

interface MemberProtocol {
    [IPageStatus.UNKNOW]: any;
    [IPageStatus.TEASER]: MemberProtocolItem[];
    [IPageStatus.ACTIVITY]: MemberProtocolItem[];
    [IPageStatus.RETURN]: MemberProtocolItem[];
    [IPageStatus.END]: MemberProtocolItem[];
}

interface MembersState {
    timeLine: ITimeLine | null;
    isLogin: boolean;
    pageStatus: IPageStatus;
    rewardRecord: any;
    joinUsWinStatus: boolean;
    protocol: MemberProtocol;
    secKillisBegin: boolean; // 秒杀是否开始
    secKillProduct: IProductItem[];
    // 25新增
    inBlackList: boolean; // 是否在黑名单中
    campaignInfo: {
        campaignId: string;
    } | null; // 活动详情
    // 基础信息
    referralInfo: ICurrentPlanInfo | null;
}

type MembersAction = {
    type: string;
    payload: any;
};

const initState: MembersState = {
    pageStatus: IPageStatus.TEASER,
    timeLine: null,
    isLogin: false,
    rewardRecord: [],
    joinUsWinStatus: false,
    protocol: {
        [IPageStatus.UNKNOW]: [],
        [IPageStatus.TEASER]: [],
        [IPageStatus.ACTIVITY]: [],
        [IPageStatus.RETURN]: [],
        [IPageStatus.END]: [],
    },
    secKillisBegin: false,
    secKillProduct: [],
    inBlackList: false,
    campaignInfo: null,
    referralInfo: null,
};

const fsReducer = (state: MembersState, action: MembersAction): MembersState => {
    const { type, payload } = action;
    switch (type) {
        case 'changePageStatus':
            return { ...state, pageStatus: payload };
        case 'rewardRecord':
            return { ...state, rewardRecord: payload };
        case 'changeJoinUsWinStatus':
            return { ...state, joinUsWinStatus: payload };
        case 'changeSecKillisBegin':
            return { ...state, secKillisBegin: payload };
        case 'changeSecKillProduct':
            return { ...state, secKillProduct: payload };
        case 'changeCampaignInfo':
            return { ...state, campaignInfo: payload };
        case 'changeInBlackList':
            return { ...state, inBlackList: payload };
        case 'changeReferralInfo':
            return { ...state, referralInfo: payload };
        default:
            return state;
    }
};

export const MembersContext = createContext<{ state: MembersState; dispatch: Dispatch<MembersAction> }>({
    state: initState,
    dispatch: () => null,
});

export function MembersProvider({ children, ...props }: { children: ReactNode; state?: any }) {
    const [state, dispatch] = useReducer(fsReducer, Object.assign(initState, props.state || {}));
    return <MembersContext.Provider value={{ state, dispatch }}>{children}</MembersContext.Provider>;
}

export const useMembersStore = () => {
    const store = useContext(MembersContext);
    return store.state;
};

export const useMembersDispatch = () => {
    const store = useContext(MembersContext);
    return store.dispatch;
};
